import React, { useState } from 'react'

import { renderCell } from 'pages/admin/sql/format'

const TYPES = ['select', 'update', 'delete', 'insert']

const PRESETS = [
	{
		'name': 'Открытые чеки',
		'query': 'select id, cheque_number, status, cloud_id, external_id, total_amount, cheque_opened_at\nfrom cheques\nwhere status <> 10 and status <> -1\norder by id desc\nlimit 50',
	},
	{
		'name': 'Последние чеки',
		'query': 'select id, cheque_number, status, cloud_id, external_id, synchronized, cheque_opened_at\nfrom cheques\norder by id desc\nlimit 50',
	},
	{
		'name': 'Несинхронизированные',
		'query': 'select id, cheque_number, status, cloud_id, cheque_closed_at\nfrom cheques\nwhere synchronized = 0 and status = 10\norder by id desc\nlimit 50',
	},
	{
		'name': 'Смены',
		'query': 'select * from shifts order by id desc limit 20',
	},
	{
		'name': 'Размер таблиц',
		'query': 'select relname as table_name, n_live_tup as rows_count\nfrom pg_stat_user_tables\norder by n_live_tup desc\nlimit 30',
	},
]

/**
 * Прямой доступ к локальной базе кассы. То же, что было на этой странице
 * раньше, но с ответом: результат прилетает обратно тем же сокетом и
 * сопоставляется с запросом по номеру.
 *
 * allowWrite = false (партнёрский раздел) — выбор типа не показываем вовсе:
 * запись в базу клиента бэк всё равно отклонит, а лишний пункт в списке
 * читался бы как разрешение.
 */
function SqlTab({ monitor, allowWrite = true }) {
	const [type, setType] = useState('select')
	const [query, setQuery] = useState('select * from cheques order by id desc limit 20')
	const [result, setResult] = useState(null)
	const [loading, setLoading] = useState(false)

	async function run() {
		if (!query.trim()) return

		setLoading(true)
		const response = await monitor.query(query, type)
		setResult(response)
		setLoading(false)
	}

	const columns = result?.rows?.length ? Object.keys(result.rows[0]) : []

	return (
		<>
			<div className="card mb-3">
				<div className="card-body">
					<div className="row">
						{allowWrite &&
							<div className="form-group col-md-2">
								<label>Тип</label>
								<select className="form-select" value={type}
									onChange={(e) => setType(e.target.value)}>
									{TYPES.map((item) => (
										<option key={item} value={item}>{item}</option>
									))}
								</select>
							</div>
						}
						<div className={allowWrite ? 'form-group col-md-10' : 'form-group col-md-12'}>
							<label>Готовые запросы</label>
							<div className="d-flex gap-2 flex-wrap">
								{PRESETS.map((preset) => (
									<button key={preset.name} type="button"
										className="btn btn-sm btn-outline-primary"
										onClick={() => { setType('select'); setQuery(preset.query) }}>
										{preset.name}
									</button>
								))}
							</div>
						</div>
					</div>

					<div className="form-group">
						<label>Запрос</label>
						<textarea className="form-control" rows="6" spellCheck="false"
							style={{ 'fontFamily': 'monospace' }}
							value={query}
							onChange={(e) => setQuery(e.target.value)} />
					</div>

					{type !== 'select' &&
						<div className="alert alert-warning py-1 fz14">
							Запрос изменит данные на боевой кассе клиента. Откатить его отсюда нельзя.
						</div>
					}

					<button type="button" className="btn btn-primary"
						disabled={loading}
						onClick={() => run()}>
						{loading ? 'Выполняется…' : 'Выполнить'}
					</button>
				</div>
			</div>

			{result &&
				<div className="card">
					<div className="card-body">
						<div className="d-flex gap-3 fz14 text-muted mb-2">
							<span>Строк: {result.rows.length}</span>
							{result.took_ms !== null && <span>Ответ кассы: {result.took_ms} мс</span>}
						</div>

						{result.error &&
							<div className="alert alert-danger">{result.error}</div>
						}

						{!result.error && result.rows.length === 0 &&
							<div className="text-muted">Запрос выполнен, строк не вернулось.</div>
						}

						{result.rows.length > 0 &&
							<div className="table-responsive" style={{ 'maxHeight': '600px' }}>
								<table className="table table-bordered table-sm mb-0">
									<thead>
										<tr>
											{columns.map((key) => (
												<th key={key} className="text-nowrap">{key}</th>
											))}
										</tr>
									</thead>
									<tbody>
										{result.rows.map((row, index) => (
											<tr key={index}>
												{columns.map((key) => (
													<td key={key}>{renderCell(row[key])}</td>
												))}
											</tr>
										))}
									</tbody>
								</table>
							</div>
						}
					</div>
				</div>
			}
		</>
	)
}

export default SqlTab
